const NotHaveAccess = () => {
    return (
        <div style={{
            height: '80vh'
        }} className="d-flex justify-content-center align-items-center w-100">403 | Not Have Access</div>
    )
}

export default NotHaveAccess